import {ButtonRaw} from '@/components/Button';
import {AutoDeliveryFrequency} from '@/consts/icc/iccAutoDeliveryStatusTypes';

import {getFrequencyOptions} from '../frequencyContentMapper';
import {getRescheduleContent} from '../utils/getRescheduleContent';

type RescheduleFrequencyStepProps = {
    onSelectFrequency: (frequency: AutoDeliveryFrequency) => void;
    titleId: string;
};

const RescheduleFrequencyStep = ({onSelectFrequency, titleId}: RescheduleFrequencyStepProps) => {
    const selectFrequencyContent = getRescheduleContent()?.selectFrequencyContent;
    const options = getFrequencyOptions(selectFrequencyContent);
    const {title} = selectFrequencyContent ?? {};

    return (
        <div className='flex flex-col gap-8'>
            {title && (
                <h2 id={titleId} className='mb-0 text-28'>
                    {title}
                </h2>
            )}
            <div className='flex flex-col gap-2'>
                {options.map(({key, label, alt}) => (
                    // @ts-ignore
                    <ButtonRaw
                        key={key}
                        onClick={() => onSelectFrequency(key)}
                        className='w-full rounded-xl border border-solid border-primary-dark-15 bg-primary-dark-5 p-4 text-16 font-bold text-primary-dark'
                        aria-label={alt}
                    >
                        {label}
                    </ButtonRaw>
                ))}
            </div>
        </div>
    );
};

export default RescheduleFrequencyStep;
